import { isMobile, isMobileOnly, isTablet } from 'mobile-device-detect';

export const getCountryList = state => {
    return state.country_list
}

export const getSalutationList = state => {
    return state.salutation_list
}

export const getVisitorGeographyDetail = state => {
    return state.visitor_geography_detail
}

export const isMobileDevice = state => {
    return isMobile
}

export const isMobileOnlyDevice = state => {
    return isMobileOnly
}

export const isTabletOnlyDevice = state => {
    return isTablet
}

export const getScreenWidth = state => {
    return parseInt(state.screen_width)
}

export const getFontSizes = state => {
    return state.font_sizes
}

export const getETATimings = state => {
    return state.timings
}

export const getFeatureListPortWidth = state => {
    return state.feature_list_port
}

export const getMeta = state => {
    return state.meta
}


// WEBPACK FOOTER //
// ./src/store/modules/master/getters.js